'use strict';
var numberIsFinite = require('is-finite');

module.exports = Number.isInteger || function (x) {
	return numberIsFinite(x) && Math.floor(x) === x;
};



//////////////////
// WEBPACK FOOTER
// ../~/number-is-integer/index.js
// module id = 2705
// module chunks = 0